import styled from "styled-components"
export const Header = styled.header`
  background-color: ${({ theme }) => theme.colors.azul};
  padding: auto;
  height: ${({ scrolled }) => (scrolled ? '7vh' : '10vh')};
  transition: height 0.3s ease;
  position: fixed;
  width: 100vw;
  top: 0;
  z-index: 9;
  .inside {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    height: 100%;
  }
  .inside .navbar {
    margin-left: auto;
  }
  .navbar{
    display: flex;
    flex-direction: row;
    align-items: center;
    position: static;
    gap: 0.8rem;
  }
  .navbar li {
    padding: 0;
    margin: 0;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 0.8rem;
  }
  .icondownNav{
    margin-left:.5rem;
    vertical-align: text-top;
  }
  img {
    height: ${({ scrolled }) => (scrolled ? '5vh' : '7vh')};
    width: auto;
    transition: height 0.3s ease;
  }
  .header__redes {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    a {
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.colors.amarillo};
      font-size: 1.4rem;
      transition: 0.3s;
      &:hover {
        color: white;
      }
    }
    @media (max-width: 1023px) {
      display: none;
    }
  }
  li {
    list-style: none;
    display: flex;
    &::after {
      content: "";
      display: block;
      width: 2px;
      height: 1rem;
      background-color: ${({ theme }) => theme.colors.amarillo};
    }
    &:last-child a {
      margin-right: 0;
    }
    &:last-child::after {
      content: none;
    }
    a {
      margin-right: 0;
      color: ${({ theme }) => theme.colors.amarillo};
      text-decoration: none;
      text-align: center;
    }
  }
  @media (max-width: 1000px) {
    .inside .navbar {
      flex-direction: column;
      position: fixed;
      right: 0;
      top: ${({ scrolled }) => (scrolled ? '7vh' : '10vh')};
      bottom: 0;
      transition: transform 0.3s ease-in-out;
      justify-content:space-between;
      width: 60%;
      background-color:${({theme})=>theme.colors.azul}
    }
    .navbar li {
      padding-left:0;
      &:nth-child(3){
        flex-direction:column;
        justify-content:center;
      }
      &::after {
        content: none;
      }
    }
  }
`
export const Navbar = styled.nav`
  @media  (max-width:1000px){
  /* display: ${({ open }) => open ? 'flex' : 'none !important'}; */
  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
  padding:1rem;
  }

`
